const resources = [
  {
    icon: "ri-government-line",
    title: "U.S. State Department Passport Services",
    desc: "Official information on passport requirements, fees, and application forms.",
    link: "https://travel.state.gov/content/travel/en/passports.html",
    label: "travel.state.gov",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Find Acceptance Facilities",
    desc: "Locate authorized passport acceptance locations near Sioux Falls.",
    link: "https://iafdb.travel.state.gov/",
    label: "iafdb.travel.state.gov",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Schedule a Passport Appointment",
    desc: "Book an appointment at the Minneapolis Passport Agency for genuine emergencies.",
    link: "https://passportappointment.travel.state.gov/",
    label: "passportappointment.travel.state.gov",
  },
  {
    icon: "ri-search-line",
    title: "Check Application Status",
    desc: "Track the status of your pending U.S. passport application online.",
    link: "https://passportstatus.state.gov/",
    label: "passportstatus.state.gov",
  },
  {
    icon: "ri-file-list-3-line",
    title: "DS-11 Application (New Passport)",
    desc: "Download the official DS-11 form for first-time U.S. passport applicants.",
    link: "https://eforms.state.gov/Forms/ds11.pdf",
    label: "eforms.state.gov",
  },
  {
    icon: "ri-file-list-line",
    title: "DS-82 Application (Renewal)",
    desc: "Download the official DS-82 form for eligible adult passport renewals.",
    link: "https://eforms.state.gov/Forms/ds82.pdf",
    label: "eforms.state.gov",
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Passport Resources for Sioux Falls Residents
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base">
            Official government links and resources for Sioux Falls and South Dakota passport applicants.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {resources.map((r, i) => (
            <a
              key={i}
              href={r.link}
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="group bg-white rounded-lg p-5 border border-gray-200 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-3">
                <i className={`${r.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-1.5">{r.title}</h3>
              <p className="text-gray-500 text-xs leading-relaxed mb-3 flex-1">{r.desc}</p>
              <span className="text-[#F6C344] text-xs font-semibold group-hover:underline">{r.label} &rarr;</span>
            </a>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-lg border border-gray-200 p-6 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div>
            <h3 className="font-bold text-[#1A365D] text-base mb-2">Other South Dakota Cities We Serve</h3>
            <div className="flex flex-wrap gap-2">
              {[
                { name: "Rapid City", href: "/cities/rapid-city" },
                { name: "Aberdeen SD", href: "/cities/aberdeen-sd" },
                { name: "South Dakota Hub", href: "/states/south-dakota" },
                { name: "Fargo ND", href: "/cities/fargo" },
                { name: "Bismarck ND", href: "/cities/bismarck" },
                { name: "Billings MT", href: "/cities/billings" },
              ].map((city, i) => (
                <a
                  key={i}
                  href={city.href}
                  className="text-xs font-semibold text-[#1A365D] bg-[#EEF2F8] hover:bg-[#F6C344] hover:text-[#1A365D] px-3 py-1.5 rounded-full transition-all whitespace-nowrap"
                >
                  {city.name}
                </a>
              ))}
            </div>
          </div>
          <div className="text-center md:text-right">
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
            >
              Start My Passport Now <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}